import RestClient from './RestClient';
import { Member } from '../../models';

class Members extends RestClient {
    constructor() {
        super({
            "model": Member,
            "entryPoint": "member",
            "resource": "member",
            "resources": "members",
            "sortBy": "lastname",
        });

        this.MEMBER_CARD_PDF_PATH = 'member_card_pdf';
    }

    downloadMemberCard(member) {
        return this.GET(`/${this.entryPoint}/${this.MEMBER_CARD_PDF_PATH}/${member.id}`)
            .then(res => res.blob())
            .then(blob => {
                return { file: blob };
            });
    }
}

const MembersApi = new Members();

export default MembersApi;
